import ReactDOM from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { loadAnalytics } from '@app/analytics';

loadAnalytics();

ReactDOM.createRoot(document).render(<HydratedRouter />);
